import { z } from 'zod';

export const UserProfileSchema = z.object({
  id: z.number(),
  email: z.string(),
  name: z.string(),
  roles: z.array(z.string()),
  department: z.string().nullable(),
});

export type UserProfile = z.infer<typeof UserProfileSchema>;

export const LoginRequestSchema = z.object({
  email: z.string().email(),
  password: z.string().min(8).max(128),
});

export type LoginRequest = z.infer<typeof LoginRequestSchema>;

export const LoginResponseSchema = z.object({
  accessToken: z.string(),
  user: UserProfileSchema,
});

export type LoginResponse = z.infer<typeof LoginResponseSchema>;

export const RefreshResponseSchema = z.object({
  accessToken: z.string(),
  user: UserProfileSchema,
});

export type RefreshResponse = z.infer<typeof RefreshResponseSchema>;

export const JwtPayloadSchema = z.object({
  // sub is a stringified numeric user ID (e.g. "42") — use Number(sub) to get the numeric value
  sub: z.string(),
  email: z.string(),
  // Required (non-optional) array — a legacy `{ role: 'sales' }` payload with
  // no `roles` key fails parsing on this missing required key.
  roles: z.array(z.string()),
  jti: z.string().uuid(),
  iat: z.number(),
  exp: z.number(),
});

export type JwtPayload = z.infer<typeof JwtPayloadSchema>;
